<table class="basicTable" style="width: 100%">
  <thead>
  <tr>
    <th colspan="100">Controller Locks</th>
  </tr>
  <tr>
    <th>Lock #</th>
    <th>Open Requests</th>
    <th>Lock Name</th>
    <th>Lock Type</th>
    <th style="min-width:215px;">Access Categories</th>
    <th style="min-width: 100px">Lock Status</th>
    <th>Create Date</th>
    <th *ngIf="authService.hasRole('SITE_LOCK_COMPANY') && (controllerComponent.controller.otpVersion === 'v2' || controllerComponent.controller.locks.length === 0)">Actions</th>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngFor="let lock of locks; let i = index">
    <tr >
      <td>
        <input style="width: 50px;"
               [(ngModel)]="lock.lockNumber"
               [name]="'lockNumber'+i"
               [id]="'lockNumber'+i"
               required
               [microMin]="0"
               [disabled]="!authService.hasRole('SITE_LOCK_COMPANY') || controllerComponent.controller.otpVersion === undefined || controllerComponent.controller.otpVersion === 'v1'"/>
      </td>
      <td [ngClass]="lock.openAccessRequestCount > 0 ? 'CRITICAL' : ''">
        {{lock.openAccessRequestCount}}
      </td>
      <td>
        <input
               [(ngModel)]="lock.name"
               [name]="'lockName'+i"
               [id]="'lockName'+i"
               [placeholder]="lock.name ?? controllerComponent.controller.name + '/' + lock.lockNumber"
               [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')" />
      </td>
      <td>
        <micro-saLock-type-select #lockType="ngModel"
                                  [(ngModel)]="lock.type"
                                  [required]="true"
                                  [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')"
                                  (saLockTypeChange)="typeChange(lock)"
                                  [id]="'lockType'+i"
                                  [name]="'lockType'+i">
        </micro-saLock-type-select>
      </td>
      <td>
        <div *ngFor="let category of lock.accessCategoryIds; let j = index">
          <table style="width: 100%; border: none;">
            <tr>
              <td style="width: 100%; border: none; vertical-align: middle;">
                <micro-saAccessCategory-lookup [categoryId]="category"
                                               [link]="true">
                </micro-saAccessCategory-lookup>
              </td>
              <td style="border: none; vertical-align: middle;">
                <mat-icon class="text-error" style="cursor: pointer;"
                          matTooltip="Remove access category"
                          matTooltipShowDelay="1500"
                          (click)="removeAccessCategory(lock, category)">cancel</mat-icon>
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="authService.hasRole('SITE_LOCK_COMPANY')">
          <table style="width: 100%; border: none;">
            <tr>
              <td style="width: 100%; border: none; vertical-align: middle;">
                <micro-access-category-select [(ngModel)]="newCategoryIds[lock.lockNumber.toString()]"
                                              [required]="true"
                                              [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')"
                                              (categoryIdChange)="addAccessCategory(lock, $event)"
                                              id="newCategoryId"
                                              name="newCategoryId">
                </micro-access-category-select>
              </td>
              <td style="border: none; vertical-align: middle;">
                <mat-icon class="text-success"
                          matTooltip="Select access category to add"
                          matTooltipShowDelay="1500">add_circle</mat-icon>
              </td>
            </tr>
          </table>
        </div>
      </td>
      <td>
        <span [class]="lock.status === 'LOCK_DELETED' ? 'text-error' : ''">{{lock.status ?? 'NEW'}}</span>
      </td>
      <td>
        {{lock.createdDate | dateTime}}
      </td>
      <td *ngIf="authService.hasRole('SITE_LOCK_COMPANY') && (controllerComponent.controller.otpVersion === 'v2' || controllerComponent.controller.locks.length === 0)">
        <button *ngIf="lock.status != 'LOCK_DELETED' && !!lock.createdDate && controllerComponent.controller.otpVersion === 'v2'"
                mat-raised-button class="text-error"
                type="button"
                (click)="deactivateLock(lock)"
                [disabled]="lock.openAccessRequestCount > 0">
          <mat-icon>no_encryption</mat-icon>
          Deactivate
        </button>
        <button *ngIf="lock.status === 'LOCK_DELETED' && !!lock.createdDate && controllerComponent.controller.otpVersion === 'v2'"
                mat-raised-button class="text-success"
                type="button"
                (click)="activateLock(lock)"
                [disabled]="lock.openAccessRequestCount > 0">
          <mat-icon>lock</mat-icon>
          Reactivate
        </button>
        <button *ngIf="!lock.createdDate"
                mat-raised-button class=""
                type="button"
                (click)="removeLock(lock)"
                [disabled]="lock.openAccessRequestCount > 0">
          <mat-icon>remove</mat-icon>
          Remove
        </button>
      </td>
    </tr>
    <ng-container *ngIf="lock.type == 'Servo' || lock.type == 'ServoDelayed' || lock.type == 'ServoEagle'">
      <tr>
        <td colspan="3"></td>
        <td colspan="1">
          <table class="basicTable vtable">
            <thead>
            <tr>
              <th colspan="99" style="text-align: center;">Lock Parameters</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <th>Select Default Parameter Set</th>
              <td>
                <mat-select [(value)]="getLockDefaultParamSet(lock.lockNumber).selected"
                            [compareWith]="paramSetCompare"
                            (selectionChange)="selectParamSet(lock, $event)"
                            placeholder="Select set or enter values"
                            [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')">
                  <mat-option *ngFor="let option of getLockDefaultParamSet(lock.lockNumber).options" [value]="option">{{option.name}}</mat-option>
                </mat-select>
              </td>
            </tr>
            <tr>
              <th><micro-valid-label [for]="'servoModel-'+i" [model]="servoModel" label="Model"></micro-valid-label></th>
              <td>
                <micro-saLock-servoModel-select #servoModel="ngModel"
                                                [(ngModel)]="lock.lockParam.model"
                                                [name]="'servoModel-'+i"
                                                [id]="'servoModel-'+i"
                                                [required]="true"
                                                [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')" />
              </td>
            </tr>
            <tr>
              <th><micro-valid-label [for]="'servoAngleMin'+i" [model]="servoAngleMin" label="Min Angle"></micro-valid-label></th>
              <td>
                <input #servoAngleMin="ngModel"
                       [(ngModel)]="lock.lockParam.angleMin"
                       [name]="'servoAngleMin'+i"
                       [id]="'servoAngleMin'+i"
                       required
                       [microMax]="lock.lockParam.angleMax"
                       placeholder="Minimum Servo angle"
                       [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')" />
              </td>
            </tr>
            <tr>
              <th><micro-valid-label [for]="'servoAngleMax'+i" [model]="servoAngleMax" label="Max Angle"></micro-valid-label></th>
              <td>
                <input #servoAngleMax="ngModel"
                       [(ngModel)]="lock.lockParam.angleMax"
                       [name]="'servoAngleMax'+i"
                       [id]="'servoAngleMax'+i"
                       required
                       placeholder="Maximum Servo angle"
                       [microMin]="lock.lockParam.angleMin"
                       [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')" />
              </td>
            </tr>
            <tr>
              <th><micro-valid-label [for]="'servoAngle'+i" [model]="servoAngle" label="Open Angle"></micro-valid-label><br/>
                <span *ngIf="lock.lockParam.angleMin !== undefined && lock.lockParam.angleMax !== undefined">Between {{lock.lockParam.angleMin}} and {{calculateServoAngleMax(lock)}}</span>
              </th>
              <td>
                <input #servoAngle="ngModel"
                       [(ngModel)]="lock.lockParam.angle"
                       [name]="'servoAngle'+i"
                       [id]="'servoAngle'+i"
                       required
                       [microMin] = "lock.lockParam.angleMin"
                       [microMax] = "calculateServoAngleMax(lock)"
                       placeholder="Servo angle to open"
                       [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')" />
              </td>
            </tr>
            <tr>
              <th><micro-valid-label [for]="'servoPwmMin'+i" [model]="servoPwmMin" label="Min Angle PWM"></micro-valid-label></th>
              <td>
                <input #servoPwmMin="ngModel"
                       [(ngModel)]="lock.lockParam.pwmMin"
                       [name]="'servoPwmMin'+i"
                       [id]="'servoPwmMin'+i"
                       required
                       placeholder="Minimum Servo Angle PWM"
                       [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')" />
              </td>
            </tr>
            <tr>
              <th><micro-valid-label [for]="'servoPwmMax'+i" [model]="servoPwmMax" label="Max Angle PWM"></micro-valid-label></th>
              <td>
                <input #servoPwmMax="ngModel"
                       [(ngModel)]="lock.lockParam.pwmMax"
                       [name]="'servoPwmMax'+i"
                       [id]="'servoPwmMax'+i"
                       required
                       placeholder="Maximum Servo Angle PWM"
                       [disabled]="!authService.hasRole('SITE_LOCK_COMPANY')" />
              </td>
            </tr>
          </tbody>
        </table>
        </td>
        <td colspan="2"></td>
      </tr>
    </ng-container>
  </ng-container>
  <tr *ngIf="authService.hasRole('SITE_LOCK_COMPANY') && (controllerComponent.controller.otpVersion === 'v2' || controllerComponent.controller.locks.length == 0)">
    <th colspan="99">
      <div class="hbox lightly-padded xbutton-bar">
        <button mat-raised-button class="primary" type="button" (click)="addLock()">
          <mat-icon>{{'add'}}</mat-icon>
          Add Lock
        </button>
      </div>

    </th>
  </tr>
  </tbody>
</table>

